/**
 * Sticky columns: set --sticky-col-width-0, -1, -2... on the wrapper so all sticky cells can read them (see table-grid.css).
 * Variables must be on a common ancestor; setting on each th would not be visible to sibling cells.
 */
function runAfterLayoutComplete() {
    requestAnimationFrame(function () {
        document.querySelectorAll('.table-grid--sticky').forEach(function (wrapper) {
            const stickyCells = wrapper.querySelectorAll('th.sticky-col, tbody tr:first-child td.sticky-col');
            for (let i = 0; i < stickyCells.length; i++) {
                const w = stickyCells[i].offsetWidth;
                wrapper.style.setProperty('--sticky-col-width-' + i, w + 'px');
            }
        });
    });
}

if (document.readyState === 'complete') {
    runAfterLayoutComplete();
} else {
    window.addEventListener('load', runAfterLayoutComplete);
}
window.addEventListener('resize', runAfterLayoutComplete);